import { useContext } from 'react';
import PurchaseOrderManagementContext from '../contexts/PurchaseOrderManagementContext';

const usePurchaseOrderData = () => {
  const { data } = useContext(PurchaseOrderManagementContext);
  return data;
}

export default usePurchaseOrderData;